// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/menu_background_rotated_min.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Existing CSS */
html, body {
    height: 100%;
    margin: 0;
}

body {
    position: relative;
    min-height: 100%;
    display: flex;
    flex-direction: column;
}

body::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 120%;
    background-position: center;
    background-repeat: no-repeat;
    z-index: -1; /* Ensure it stays behind the content */
}

.container {
    text-align: left;
    flex: 1 1;
}

.header-title {
    padding-top: 5rem;
    font-family: 'Palace Script MT', cursive;
    font-size: 8rem;
    text-align: center;
    color: #333; /* Change color as needed */
    margin-bottom: 20px;
    cursor: pointer;
    opacity: 0;
    transform: translateY(-20px);
    animation: fadeInUp 1s forwards;
}

.about-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 50px;
    opacity: 0;
    transform: translateY(-20px);
    animation: fadeInUp 1s forwards 0.5s;
}

.text-section {
    flex: 1 1;
    padding-right: 20px;
}

.about-text {
    font-family: 'Georgia', cursive;
    font-size: 20px;
    color: #333; /* Change color as needed */
    flex: 1 1;
    padding-right: 20px;
    opacity: 0;
    transition: opacity 0.5s ease-in-out, transform 0.3s ease-in-out;
    text-align: justify;
}

.about-text.fade-in {
    opacity: 1;
}

.image-section {
    flex: 1 1;
    display: flex;
    justify-content: center;
}

.about-image {
    width: 400px; /* Make the image larger */
    height: auto;
    flex: 1 1;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 1); /* Add drop shadow */
    transition: transform 0.3s, box-shadow 0.3s; /* Transition for hover effects */
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 1s forwards 1s;
}

.about-image:hover {
    transform: scale(1.1);
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3); /* Enhance drop shadow on hover */
    cursor: pointer;
}

.legenda-content {
    display: flex;
    align-items: flex-start;
    margin-top: 20px;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 1s forwards 1.5s;
}

.legenda-image-section {
    flex: 1 1;
    margin-right: 20px; /* Space between image and text */
}

.legenda-image {
    margin-top: 20%;
    width: 50vh;
    height: 40vh;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 1); /* Add drop shadow */
    transition: transform 0.3s, box-shadow 0.3s; /* Transition for hover effects */
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 1s forwards 2s;
}

.legenda-image:hover {
    transform: scale(1.1);
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3); /* Enhance drop shadow on hover */
    cursor: pointer;
}

.legenda-text-section {
    flex: 2 1;
}

.legenda-text {
    margin-top: 0;
    margin-left: 10%;
    font-size: 20px;
    line-height: 1.6;
    text-align: justify;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 1s forwards 2.5s;
}

.text-end {
    font-family: Georgia, 'Times New Roman', Times, serif;
}

@keyframes fadeInUp {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Mobile specific CSS */
@media (max-width: 768px) {

    .content{
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .about-content, .legenda-content {
        flex-direction: column;
        align-items: center;
        margin: 0 !important;
    }

    .text-section, .image-section, .legenda-text-section {
        padding: 0;
        text-align: center;
    }

    .legenda-image-section{
        padding: 0;
        margin-bottom: 10%;
        text-align: center;
    }

    .about-image {
        width: 100%;
        
        margin-bottom: 20px;
    }

    .legenda-image {
        width: 100%;
        height: auto;
        margin-top: 0 !important;
        /* max-width: 400px; Adjust as necessary */
        margin-bottom: 20px;
    }

    .about-text {
        padding: 0 10px;
    }

    .legenda-text {
        /* padding-right: 10%; */
        margin: 0 !important;
    }

    .legenda-image-section {
        margin-right: 0;
    }

    h1 {
        font-size: 6rem !important;
    }

    h2 {
        font-size: 5rem !important;
    }
}

@media (min-width: 769px) and (max-width: 1024px) {
    .content{
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    
    footer {
      margin-top:0% !important;
    }

    .about-image {
        width: 100%;
        
        margin-bottom: 20px;
    }

  
    .legenda-image {
        width: 110%;
        /* margin-top: 100%; */
        height: auto;
        margin-top: 80% !important;
        /* max-width: 400px; Adjust as necessary */
        margin-bottom: 20px;
    }
    /* .right-side {
      width: 50% !important;
      margin-right: 0;
      padding-top: 20% !important;
      padding-left: 7% !important;
      padding-bottom: 20% !important;
      z-index: 101;
    } */
    
  }

  @media (min-width: 3840px) {
 
    .legenda-image {
        width: 110%;
        /* margin-top: 100%; */
        height: auto;
        /* margin-top: 80% !important; */
        /* max-width: 400px; Adjust as necessary */
        margin-bottom: 20px;
    }
  }
  
`, "",{"version":3,"sources":["webpack://./src/components/about-us/AboutUs.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAAqE;IACrE,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW,EAAE,uCAAuC;AACxD;;AAEA;IACI,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,eAAe;IACf,kBAAkB;IAClB,WAAW,EAAE,2BAA2B;IACxC,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,SAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,WAAW,EAAE,2BAA2B;IACxC,SAAO;IACP,mBAAmB;IACnB,UAAU;IACV,gEAAgE;IAChE,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAO;IACP,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY,EAAE,0BAA0B;IACxC,YAAY;IACZ,SAAO;IACP,wCAAwC,EAAE,oBAAoB;IAC9D,2CAA2C,EAAE,iCAAiC;IAC9E,UAAU;IACV,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,2CAA2C,EAAE,iCAAiC;IAC9E,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,SAAO;IACP,kBAAkB,EAAE,iCAAiC;AACzD;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,wCAAwC,EAAE,oBAAoB;IAC9D,2CAA2C,EAAE,iCAAiC;IAC9E,UAAU;IACV,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,2CAA2C,EAAE,iCAAiC;IAC9E,eAAe;AACnB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,wBAAwB;AACxB;;IAEI;QACI,yDAAqE;QACrE,2BAA2B;QAC3B,4BAA4B;QAC5B,sBAAsB;IAC1B;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,WAAW;;QAEX,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,wBAAwB;QACxB,0CAA0C;QAC1C,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;QACxB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,yDAAqE;QACrE,2BAA2B;QAC3B,4BAA4B;QAC5B,sBAAsB;IAC1B;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;QACI,WAAW;;QAEX,mBAAmB;IACvB;;;IAGA;QACI,WAAW;QACX,sBAAsB;QACtB,YAAY;QACZ,0BAA0B;QAC1B,0CAA0C;QAC1C,mBAAmB;IACvB;IACA;;;;;;;OAOG;;EAEL;;EAEA;;IAEE;QACI,WAAW;QACX,sBAAsB;QACtB,YAAY;QACZ,gCAAgC;QAChC,0CAA0C;QAC1C,mBAAmB;IACvB;EACF","sourcesContent":["/* Existing CSS */\nhtml, body {\n    height: 100%;\n    margin: 0;\n}\n\nbody {\n    position: relative;\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\nbody::before {\n    content: '';\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url('../../assets/menu_background_rotated_min.jpg');\n    background-size: 120%;\n    background-position: center;\n    background-repeat: no-repeat;\n    z-index: -1; /* Ensure it stays behind the content */\n}\n\n.container {\n    text-align: left;\n    flex: 1;\n}\n\n.header-title {\n    padding-top: 5rem;\n    font-family: 'Palace Script MT', cursive;\n    font-size: 8rem;\n    text-align: center;\n    color: #333; /* Change color as needed */\n    margin-bottom: 20px;\n    cursor: pointer;\n    opacity: 0;\n    transform: translateY(-20px);\n    animation: fadeInUp 1s forwards;\n}\n\n.about-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 50px;\n    opacity: 0;\n    transform: translateY(-20px);\n    animation: fadeInUp 1s forwards 0.5s;\n}\n\n.text-section {\n    flex: 1;\n    padding-right: 20px;\n}\n\n.about-text {\n    font-family: 'Georgia', cursive;\n    font-size: 20px;\n    color: #333; /* Change color as needed */\n    flex: 1;\n    padding-right: 20px;\n    opacity: 0;\n    transition: opacity 0.5s ease-in-out, transform 0.3s ease-in-out;\n    text-align: justify;\n}\n\n.about-text.fade-in {\n    opacity: 1;\n}\n\n.image-section {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n}\n\n.about-image {\n    width: 400px; /* Make the image larger */\n    height: auto;\n    flex: 1;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 1); /* Add drop shadow */\n    transition: transform 0.3s, box-shadow 0.3s; /* Transition for hover effects */\n    opacity: 0;\n    transform: translateY(20px);\n    animation: fadeInUp 1s forwards 1s;\n}\n\n.about-image:hover {\n    transform: scale(1.1);\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3); /* Enhance drop shadow on hover */\n    cursor: pointer;\n}\n\n.legenda-content {\n    display: flex;\n    align-items: flex-start;\n    margin-top: 20px;\n    opacity: 0;\n    transform: translateY(20px);\n    animation: fadeInUp 1s forwards 1.5s;\n}\n\n.legenda-image-section {\n    flex: 1;\n    margin-right: 20px; /* Space between image and text */\n}\n\n.legenda-image {\n    margin-top: 20%;\n    width: 50vh;\n    height: 40vh;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 1); /* Add drop shadow */\n    transition: transform 0.3s, box-shadow 0.3s; /* Transition for hover effects */\n    opacity: 0;\n    transform: translateY(20px);\n    animation: fadeInUp 1s forwards 2s;\n}\n\n.legenda-image:hover {\n    transform: scale(1.1);\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3); /* Enhance drop shadow on hover */\n    cursor: pointer;\n}\n\n.legenda-text-section {\n    flex: 2;\n}\n\n.legenda-text {\n    margin-top: 0;\n    margin-left: 10%;\n    font-size: 20px;\n    line-height: 1.6;\n    text-align: justify;\n    opacity: 0;\n    transform: translateY(20px);\n    animation: fadeInUp 1s forwards 2.5s;\n}\n\n.text-end {\n    font-family: Georgia, 'Times New Roman', Times, serif;\n}\n\n@keyframes fadeInUp {\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Mobile specific CSS */\n@media (max-width: 768px) {\n\n    .content{\n        background-image: url('../../assets/menu_background_rotated_min.jpg');\n        background-position: center;\n        background-repeat: no-repeat;\n        background-size: cover;\n    }\n    .about-content, .legenda-content {\n        flex-direction: column;\n        align-items: center;\n        margin: 0 !important;\n    }\n\n    .text-section, .image-section, .legenda-text-section {\n        padding: 0;\n        text-align: center;\n    }\n\n    .legenda-image-section{\n        padding: 0;\n        margin-bottom: 10%;\n        text-align: center;\n    }\n\n    .about-image {\n        width: 100%;\n        \n        margin-bottom: 20px;\n    }\n\n    .legenda-image {\n        width: 100%;\n        height: auto;\n        margin-top: 0 !important;\n        /* max-width: 400px; Adjust as necessary */\n        margin-bottom: 20px;\n    }\n\n    .about-text {\n        padding: 0 10px;\n    }\n\n    .legenda-text {\n        /* padding-right: 10%; */\n        margin: 0 !important;\n    }\n\n    .legenda-image-section {\n        margin-right: 0;\n    }\n\n    h1 {\n        font-size: 6rem !important;\n    }\n\n    h2 {\n        font-size: 5rem !important;\n    }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n    .content{\n        background-image: url('../../assets/menu_background_rotated_min.jpg');\n        background-position: center;\n        background-repeat: no-repeat;\n        background-size: cover;\n    }\n    \n    footer {\n      margin-top:0% !important;\n    }\n\n    .about-image {\n        width: 100%;\n        \n        margin-bottom: 20px;\n    }\n\n  \n    .legenda-image {\n        width: 110%;\n        /* margin-top: 100%; */\n        height: auto;\n        margin-top: 80% !important;\n        /* max-width: 400px; Adjust as necessary */\n        margin-bottom: 20px;\n    }\n    /* .right-side {\n      width: 50% !important;\n      margin-right: 0;\n      padding-top: 20% !important;\n      padding-left: 7% !important;\n      padding-bottom: 20% !important;\n      z-index: 101;\n    } */\n    \n  }\n\n  @media (min-width: 3840px) {\n \n    .legenda-image {\n        width: 110%;\n        /* margin-top: 100%; */\n        height: auto;\n        /* margin-top: 80% !important; */\n        /* max-width: 400px; Adjust as necessary */\n        margin-bottom: 20px;\n    }\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
